import { env } from 'config';
import {
  P2PProviderPayinCustomerDailyLimit,
  PaginatedData,
  QueryParams,
} from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/p2p-providers-payin-customer-daily-limits`;

export const p2pProviderPayinCustomerDailyLimitsApi = {
  getAllPaginated: async (
    params?: Partial<QueryParams>,
  ): Promise<PaginatedData<P2PProviderPayinCustomerDailyLimit>> =>
    (await apiUtils.getWithQueryParams(`${url}/paginated`, params)).data,
};
